export const IconTriangle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    x="0"
    y="0"
    width="20"
    version="1.1"
    viewBox="0 0 29 29"
  >
    <path
      fill="none"
      stroke="#55658D"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="2"
      d="m20.5 11.5-6 6-6-6"
    />
  </svg>
);
